import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statExaminationScheduleModule: LocaleModule = {
  name: "statExaminationSchedule",
  messages: { en: en, it: it },
};
